export default "__VITE_ASSET__CjZvlR6Q__"